import { render } from "./TermService.vue?vue&type=template&id=3a85d89d&scoped=true"
import script from "./TermService.vue?vue&type=script&lang=js"
export * from "./TermService.vue?vue&type=script&lang=js"

import "./TermService.vue?vue&type=style&index=0&id=3a85d89d&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a85d89d"]])

export default __exports__